import { Page } from "../../models/api/page/page";
import { ListSortDirection, Sort } from "../../models/api/sort";
import { LegalEntityEventsFilter } from "../../models/legal-entity-events";
import { LegalEntityEventDTO } from "../../models/legal-entity-events/legal-entity-event-dto";
import { LegalEntityEventSTO } from "../../models/legal-entity-events/legal-entity-event-sto";
import { SearchOptions } from "../../models/search-options/search-options";

import { toastifyResponse } from "../../utils/toastify-response/toastify-response";
import { BaseApiService } from "../base/base-api.service";

export class LegalEntityEventsApiService extends BaseApiService<LegalEntityEventDTO, LegalEntityEventSTO> {
  constructor() {
    super({
      servicePath: "/LegalEntityEvents",
      loadItemsPath: "/GetLegalEntityEvents",
      saveItemsPath: "/SaveLegalEntityEvents",
    });
    this.defaultSort = [
      {
        name: "date",
        direction: ListSortDirection.Descending,
      } as Sort,
    ];
  }
}

export const loadLegalEntityEvents = async (
  propsFilter: LegalEntityEventsFilter,
  searchOptions?: SearchOptions,
  page?: Page,
  signal?: AbortSignal
) => {
  const response = await new LegalEntityEventsApiService().loadItems(
    propsFilter,
    searchOptions?.query ?? "",
    undefined,
    page,
    searchOptions?.exactMatch ?? false,
    60,
    signal
  );

  toastifyResponse(response, "failed");

  return response;
};

export const saveLegalEntityEvent = async (legalEntityEvent: LegalEntityEventSTO) => {
  const response = await new LegalEntityEventsApiService().saveItems([legalEntityEvent]);

  toastifyResponse(response, "failed");

  return response;
};
